import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ExplorerPurchase from '../components/ExplorerPurchaseNew';
import EnterprisePurchase from '../components/EnterprisePurchaseNew';
import { setCurrentPage } from '../redux/app.slice';
import Logo from '../images/lavenir-logo.png';

const SubscribeNew = () => {
  const dispatch = useDispatch();
  const [showExplorerForm, setShowExplorerForm] = useState(false);
  const [showEnterpriseForm, setShowEnterpriseForm] = useState(false);

  React.useEffect(() => {
    dispatch(setCurrentPage('subscribe-new'));
  }, [dispatch]);

  if (showExplorerForm) {
    return <ExplorerPurchase onBack={() => setShowExplorerForm(false)} />;
  }

  if (showEnterpriseForm) {
    return <EnterprisePurchase onBack={() => setShowEnterpriseForm(false)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#eef2f3] via-[#d9e6f2] to-[#eef2f3]">
      <div className="max-w-[1325px] mx-auto py-12 px-8">
        <div className="bg-white rounded-[12px] shadow-lg p-8">
          <img src={Logo} alt="LavenirAI" className="h-[40px] mx-auto mb-6" />
          
          <h1 className="text-[#10193A] text-[56px] font-bold text-center mb-8">
            PLANS
            <div className="w-20 h-0.5 bg-[#10193A] mx-auto mt-2"></div>
          </h1>

          <div className="flex justify-center gap-16">
            <div className="w-[480px] bg-white rounded-[12px] p-8 shadow-2xl shadow-gray-500/60 flex flex-col">
              <h2 className="text-[#10193A] text-3xl font-bold mb-8 text-center">Explorer (1-9 Seats)</h2>
              <ul className="space-y-5 mb-16">
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>40+ chapters (40+ hours of learning content)</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>17 AI negotiation case study roleplays</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Ask Harini (AI assistant trained on procurement and negotiation)</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>AI Negotiation Plan generator (with AI consultation of plan)</span>
                </li>
              </ul>
              <div className="mt-auto">
                <p className="text-[#10193A] text-2xl font-bold text-center mb-4">$2400/year/seat</p>
                <button 
                  onClick={() => setShowExplorerForm(true)}
                  className="w-full bg-[#10193A] text-white rounded-xl py-4"
                >
                  BUY NOW
                </button>
              </div>
            </div>

            <div className="w-[480px] bg-white rounded-[12px] p-8 shadow-2xl shadow-gray-500/60 flex flex-col">
              <h2 className="text-[#10193A] text-3xl font-bold mb-8 text-center">Enterprise (10+ Seats)</h2>
              <ul className="space-y-5 mb-16">
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Everything in Explorer</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Custom case studies</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Seat management support</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Bulk discounts, more seats</span>
                </li>
                <li className="flex items-start gap-3 text-gray-600 text-xl font-medium">
                  <span className="text-gray-600 text-xl">✔</span>
                  <span>Custom contracts and development</span>
                </li>
              </ul>
              <div className="mt-auto">
                <p className="text-[#10193A] text-2xl font-bold text-center mb-4">Request Enterprise Pricing</p>
                <button 
                  onClick={() => setShowEnterpriseForm(true)}
                  className="w-full bg-[#10193A] text-white rounded-xl py-4"
                >
                  CONTACT US
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeNew;
